(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('BillingFrequencySearch', BillingFrequencySearch);

    BillingFrequencySearch.$inject = ['$resource'];

    function BillingFrequencySearch($resource) {
        var resourceUrl =  'api/_search/billing-frequencies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
